const MAX_QTY = 5;

const LIMITED_VENDORS = [
  'kerastase',
  'kérastase',
  'loreal professionnel',
  'l’oréal professionnel',
  "l'oréal professionnel",
  'la roche-posay',
  'la roche posay',
  'cerave',
  'cera ve',
  'vichy'
];

const LIMIT_MESSAGE =
  "Maximum 5 unités autorisées pour : Kérastase, L'Oréal Professionnel, La Roche-Posay, CeraVe et Vichy.\n\n" +
  "Merci de réduire la quantité avant de finaliser votre commande.\n\n" +
  "الحد الأقصى المسموح هو 5 منتجات لعلامات:\n" +
  "Kérastase - L'Oréal Professionnel - La Roche-Posay - CeraVe - Vichy\n\n" +
  "يرجى تقليل الكمية قبل إتمام الطلب.";

function normalizeText(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, '')
    .replace(/-/g, ' ')
    .trim();
}

function isLimitedVendor(vendorName) {
  const vendor = normalizeText(vendorName);
  return LIMITED_VENDORS.some(name => vendor.includes(normalizeText(name)));
}

function cartHasInvalidQty(cart) {
  return cart.items.some(item => isLimitedVendor(item.vendor) && item.quantity > MAX_QTY);
}

function checkCartBeforeCheckout(event) {
  const checkoutElement = event.target.closest(
    'button[name="checkout"], input[name="checkout"], a[href*="/checkout"], form[action*="/checkout"]'
  );

  if (!checkoutElement) return;

  event.preventDefault();
  event.stopPropagation();

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cartHasInvalidQty(cart)) {
        alert(LIMIT_MESSAGE);
        window.location.href = '/cart';
      } else {
        window.location.href = '/checkout';
      }
    });
}

document.addEventListener('click', checkCartBeforeCheckout, true);
document.addEventListener('submit', checkCartBeforeCheckout, true);